<template>
    <div>
        <div class="warp">
            <!-- <div class="crumTitle">{{title}}</div> -->
            <div class="crumbs">
                <div class="back" @click="$router.back()" v-if="back"><i class="el-icon-arrow-left"></i><span>返回</span></div>
                <el-breadcrumb separator="/" class="crumb">
                    <el-breadcrumb-item v-for="(item,index) in crubList" :key="index">
                        <span :class="item.goback?'click':''" @click="item.goback?$router.back():null">{{item.name}}</span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
    </div>
</template>

<script>
// <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'用户认证审核'}]" :title="'用户认证审核'"/> 使用 实例
export default {
    props:{
        back:Boolean,
        crubList: Array,
        title:String
    }
}
</script>

<style lang="scss" scoped>
.warp{
    .crumTitle{
        font-size:17px;
        font-weight:bold;
        color:rgba(81,81,81,1);
        padding: 10px 0;
    }
    .crumbs{
        display: flex;
        align-items: center;
        height: 40px;
        position: relative;
        
        .back{
            font-size:14px;
            font-weight:400;
            color:rgba(81,81,81,1);
            cursor: pointer;
            margin-right: 16px;
            i{
                height: 10px;
            }
            span{
                font-size: 14px;
            }
            &:hover{
                color: #1069DD;
            }
        }
        .crumb{
            flex: 1;
            span{
                &.click{
                    cursor: pointer;
                    &:hover{
                        color: #1069DD;
                    }
                }
                font-size:14px;
                /deep/ .el-breadcrumb__inner{
                    font-weight:400;
                    color:rgba(81,81,81,1);
                }
            }
            
        }
    } 
}
</style>